import { useEffect, useId, type JSX } from "react";

import { keyboardShortcutGroups } from "../keyboard-shortcuts";

export default function KeyboardShortcutsDialog({
  open,
  onClose,
}: {
  readonly open: boolean;
  readonly onClose: () => void;
}): JSX.Element | null {
  const titleId = useId();

  useEffect(() => {
    if (!open) {
      return;
    }
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key !== "Escape") {
        return;
      }
      event.preventDefault();
      onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [onClose, open]);

  if (!open) {
    return null;
  }

  return (
    <section
      className="decision-panel decision-panel--confirm keyboard-shortcuts-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
    >
      <header>
        <p className="utility-label">Reference</p>
        <h2 id={titleId}>Keyboard shortcuts</h2>
      </header>
      <div className="keyboard-shortcuts-dialog__groups">
        {keyboardShortcutGroups().map((group) => (
          <section key={group.title}>
            <h3>{group.title}</h3>
            <dl>
              {group.items.map((item) => (
                <div key={`${group.title}:${item.action}`}>
                  <dt>
                    <kbd>{item.keys}</kbd>
                  </dt>
                  <dd>{item.action}</dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
      <div className="decision-actions">
        <button
          className="primary-action"
          type="button"
          autoFocus
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </section>
  );
}
